import { render, staticRenderFns } from "./MainAuth.vue?vue&type=template&id=5983d60f&scoped=true"
import script from "./MainAuth.vue?vue&type=script&lang=js"
export * from "./MainAuth.vue?vue&type=script&lang=js"
import style0 from "./MainAuth.vue?vue&type=style&index=0&id=5983d60f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983d60f",
  null
  
)

export default component.exports